import { Link } from 'react-router-dom';

import './giftPartnerGuide.css';

// 가이드 본문(GiftPartnerGuide)은 로그인 뒤에만 불러오는 별도 코드 조각이다.
// 경로·안내 카드처럼 다른 화면이 쓰는 것만 여기 둬서 본문이 메인 번들에 딸려 들어가지 않게 한다.
export const GIFT_PARTNER_GUIDE_PATH = '/gift-brand/api-integration/guide';

export const GiftPartnerGuideResources = () => (
  <section className="partner-guide-resources" aria-label="API 개발 가이드">
    <div>
      <strong>연동 전에 개발 가이드를 확인하세요</strong>
      <p>
        인증 방법, API 명세, 배송 처리와 웹훅 예제를 개발 담당자에게 공유할 수 있습니다.
      </p>
    </div>
    <div className="partner-guide-links">
      <Link to={GIFT_PARTNER_GUIDE_PATH}>개발 가이드 보기 →</Link>
    </div>
  </section>
);
